module.exports = __webpack_public_path__ + "static/img/id_card_2.bfdf7f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/id_card_2.png
// module id = wpOK
// module chunks = 1